var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("title",function(){return [_c('div',{staticClass:"title-area"},[_vm._v(_vm._s(_vm.item.title))]),(_vm.item.description)?_c('div',[_vm._v(_vm._s(_vm.item.description))]):_vm._e()]}),_vm._t("value",function(){return [_c('DefaultPropertyInput',{staticClass:"first-letter-uppercase",attrs:{"value":_vm.item.value,"readonly":""}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }